function init() {

    $('.person-item').click(function() {
        $('.person-item').removeClass('active');
        $(this).addClass('active');
    });

}

module.exports = {
    init: init
};